import {useState, createContext, useEffect} from 'react';
import { changeDisable, setMaskDecimal, setMaskGeneric, validateDate, getPermission, showMessageError } from '../../../classes/functions';
import './adresses.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import InputDate from '../../../components/Inputs/Date/index.js';

export default function Adresses(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [listSituacoes, setListSituacoes] = useState([]);
  const [listZonas, setListZonas] = useState([]);
  const [listTipos, setListTipos] = useState([]);

  const [armazem, setArmazem] = useState([]);
  const [descricao, setDescricao] = useState('');
  const [tipo, setTipo] = useState('');
  const [endereco, setEndereco] = useState('');
  const [unitizador, setUnitizador] = useState('');
  const [altura, setAltura] = useState('');
  const [seta, setSeta] = useState('');
  const [largura, setLargura] = useState('');
  const [comprimento, setComprimento] = useState('');
  const [capacidade, setCapacidade] = useState('');
  const [situacao, setSituacao] = useState('');
  const [nivel, setNivel] = useState('');
  const [zona_armazenagem, setZonaArmazenagem] = useState('');
  const [ativo, setAtivo] = useState('');
  const [locado, setLocado] = useState('');
  const [disponivel_operacao, setDisponivelOperacao] = useState('');
  const [inventory_audit, setInventoryAudit] = useState('');
  const [infos, setInfos] = useState({
    data_inventario: ""
  });

  useEffect(()=> {
    async function loadAdresses(){
      if (id) { 
        getOne(id, option);
      }

      getData();
    }
    loadAdresses();

  },[]);

  function validForm() {
    let controle = false;
    
    armazem.map((element) => {
      if (element.checked === true) {
        controle = true;
      }
    });

    if (controle === false) {
      toast.error('Preencha todos os campos com * antes de salvar.');
      return false;
    }
    
    if ((endereco !== '') && (descricao !== '') && (zona_armazenagem !== '') && (tipo !== '')) {
      return true;
    } else {
      toast.error('Preencha todos os campos com * antes de salvar.');
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();
     
    if (!validForm()) {
      setCarrying(false);
      return false;
    }
    
    const data = {
      row: {
        armazem: armazem,
        descricao: descricao,
        tipo: tipo,
        endereco: endereco,
        unitizador: unitizador,
        altura: altura,
        largura: largura,
        nivel: nivel,
        comprimento: comprimento,
        capacidade: capacidade,
        situacao: situacao,
        data_inventario: infos.data_inventario,
        locado: locado,
        seta: seta,
        ativo: ativo,
        inventory_audit: inventory_audit,
        disponivel_operacao: disponivel_operacao,
        zona_armazenagem: zona_armazenagem,
      }
    }

    if (id) { 
      data.row.id = id;
      api.put("/api/adresses/put", data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/adresses');
        }
      ).catch((error) => {
        console.log(error);
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/adresses/post", data)
      .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push('/adresses');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function getOne(id, option){
    api.get("/api/adresses/getList?id=" + id)
    .then((response) => {
        setArmazem(response.data.row.armazem);
        setDescricao(response.data.row.descricao);
        setTipo(response.data.row.tipo);
        setEndereco(response.data.row.endereco);
        setAltura(response.data.row.altura);
        setNivel(response.data.row.nivel);
        setUnitizador(response.data.row.unitizador);
        setLargura(response.data.row.largura);
        setComprimento(response.data.row.comprimento);
        setCapacidade(response.data.row.capacidade);
        setSituacao(response.data.row.situacao);
        setLocado(response.data.row.locado);
        setInfos((prevState) => ({...prevState, data_inventario: response.data.row.data_inventario}));
        setZonaArmazenagem(response.data.row.zona_armazenagem);
        setSeta(response.data.row.seta);
        setAtivo(response.data.row.ativo);
        setDisponivelOperacao(response.data.row.disponivel_operacao);
        setInventoryAudit(response.data.row.inventory_audit);
        setCarrying(false);
      }
    ).catch((error) => {
      setCarrying(false);
      console.log(error);
      showMessageError(error.response.data);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/adresses');
  }

  function remove(){
    api.delete("/api/adresses/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/adresses');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }
  
  async function getData() {
    api.get("/api/adresses/getDataPage")
    .then((response) => {
      setListSituacoes(response.data.situacoes);
      setListZonas(response.data.zonas);
      setListTipos(response.data.tipos);

      if (!id) {
        setArmazem(response.data.armazens);
      }
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function changeWarehouse(e) {
    let aux_warehouses = [];

    armazem.forEach((element) => {
      if (parseInt(element.id) === parseInt(e.target.value)) {
        element.checked = !element.checked;
      }

      aux_warehouses.push(element);
    });

    setArmazem(aux_warehouses);
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Endereços">
          <Link to="/adresses">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Endereço</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Endereço" value={endereco} onChange={ (e) => setEndereco(e.target.value) } maxLength="20" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Descrição</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Descrição" value={descricao} onChange={ (e) => setDescricao(e.target.value) } maxLength="30" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Nível</label><br/>
                  <input type="text" placeholder="Descrição" value={nivel} onChange={ (e) => setNivel(e.target.value) } maxLength="30" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Direção</label><br/>
                  <select value={seta} onChange={ (e) => setSeta(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    <option value='U'>Cima</option>
                    <option value='B'>Baixo</option>
                    <option value='R'>Direita</option>
                    <option value='L'>Esquerda</option>
                  </select>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Zonas de Armazenagem</label>&nbsp;<label className="required">*</label><br/>
                  <select value={zona_armazenagem} onChange={ (e) => setZonaArmazenagem(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listZonas.map((item, index) => (
                      <option key={index} value={item.id}>{item.descricao}</option>
                    ))}
                  </select>
                </div>
                
                <div className="formDiv">
                  <label>Tipo</label>&nbsp;<label className="required">*</label><br/>
                  <select value={tipo} onChange={ (e) => setTipo(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listTipos.map((item, index) => (
                      <option key={index} value={item.chave}>{item.descricao}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Situação</label><br/>
                  <select value={situacao} onChange={ (e) => setSituacao(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listSituacoes.map((item, index) => (
                      <option key={index} value={item.chave}>{item.descricao}</option>
                    ))}
                  </select>
                </div>
                
                <div className="formDiv">
                  <label>Ativo</label><br/>
                  <select value={ativo} onChange={ (e) => setAtivo(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>  
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Altura</label><br/>
                  <input type="text" placeholder="Altura" value={altura} onChange={ (e) => setAltura(setMaskDecimal(e.target.value, 2)) } maxLength="7" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Largura</label><br/>
                  <input type="text" placeholder="Largura" value={largura} onChange={ (e) => setLargura(setMaskDecimal(e.target.value, 2)) } maxLength="7" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Comprimento</label><br/>
                  <input type="text" placeholder="Comprimento" value={comprimento} onChange={ (e) => setComprimento(setMaskDecimal(e.target.value, 2)) } maxLength="7" disabled={view}/>
                </div>
                
                <div className="formDiv">
                  <label>Capacidade Kg</label><br/>
                  <input type="text" placeholder="Capacidade" value={capacidade} onChange={ (e) => setCapacidade(setMaskDecimal(e.target.value, 2)) } maxLength="10" disabled={view}/>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Unitizador</label><br/>
                  <input type="text" placeholder="Unitizador" value={unitizador} onChange={ (e) => setUnitizador(setMaskDecimal(e.target.value, 0)) } maxLength="7" disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Data Inventário</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_inventario" disabled={view} />
                </div>
                
                <div className="formDiv">
                  <label>Disponível Operação</label><br/>
                  <select value={disponivel_operacao} onChange={ (e) => setDisponivelOperacao(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>  
                
                <div className="formDiv">
                  <label>Inventário/Auditoria</label><br/>
                  <select value={inventory_audit} onChange={ (e) => setInventoryAudit(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>  
              </div>
            
              <div className="divGroup">
                <div className="formDiv">
                  <label>Locado</label><br/>
                  <select value={locado} onChange={ (e) => setLocado(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
                <div className="formDiv">
                </div>
                <div className="formDiv">
                </div>
                <div className="formDiv">
                </div>
              </div>
            </div>
            <br/>
            <div className="divGroup">
              <div className="formDivList">
                <div className="containerGroupData">
                  <h2>Armazém&nbsp;<label className="required">*</label></h2>
                  <hr></hr>
                
                  <table>
                    <thead>
                      <tr>
                        <th scope="col" className="column">#</th>
                        <th scope="col">Descrição</th>
                      </tr>
                    </thead>
                    <tbody>
                      {armazem.map((item, index)=>{
                        return(
                          <tr key={index}>
                            <td data-label="#">
                              <input type="checkbox" checked={item.checked} value={item.id} onChange={ changeWarehouse } />
                            </td>
                            <td data-label="Descrição">{item.descricao}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="formDivList">
                <label></label>
              </div>
            </div>
            {!view && <div className="formDiv">
              {getPermission('CADASTROS - ENDERECOS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('CADASTROS - ENDERECOS - EXCLUSAO') && <button type="button" className="buttonRemove" onClick={remove} disabled={view}>Excluir</button>}
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}